import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function AboutUs() {
  return <section data-section-id="252834" id="concept-section" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">

        <div className="mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-primary font-default leading-tight mb-4">相談室紹介</h1>
          <Separator className="w-12 h-0.5 bg-primary" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="order-1">
            <p className="text-primary font-bold font-default mb-3">More informal counseling.</p>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground font-default leading-tight mb-4">「ちょっと聞いてほしい」に<br />応える場所です</h2>
            <Separator className="w-12 h-0.5 bg-primary mb-8" />
            <div className="space-y-6">
              <p className="text-foreground leading-relaxed font-default">「心理カウンセリングを受けたい」と思ったとき、カウンセリングを受ける場所の選択肢は、そう多くはありません。大半の方は精神科・心療内科のある医療機関を想定されると思います。しかし、カウンセリングを受けたいと思う場所は人によって異なるのではないでしょうか。</p>
              <p className="text-foreground leading-relaxed font-default">だからこそ当ルームは「カウンセリングを受ける際の選択肢のひとつになること」を目指しています。カウンセラーが個人で運営している相談室ですので、ご予約いただいた時間帯には他の人はいません。外の音もあまり入ってくることはありませんので、自分の気持ちとゆっくり向き合うことができます。お部屋ではアロマをたいていますが、苦手な方は予約時にお伝えください。</p>
              <p className="text-foreground leading-relaxed font-default">具体的な悩みがある方はもちろん、少し話をしてみたいという方も大歓迎です。友人と話すような気持ちで、お気軽にどうぞ。カウンセラーが親身になってお話を伺います。</p>
              <p className="text-foreground leading-relaxed font-default">カウンセリングの流れは<Link to="https://yotsuya-sc-room.com/flow/" className="text-primary-heading underline underline-offset-4">こちら</Link>からご覧ください。</p>
            </div>
          </div>

          <div className="order-2">
            <img src="https://yotsuya-sc-room.com/wp-content/uploads/2026/05/ACCESS.jpg" alt="新宿四谷心理カウンセリングルームの相談室。白いソファとローテーブルのある落ち着いた空間" className="w-full rounded-lg shadow-lg object-cover aspect-[4/3]" loading="lazy" decoding="async" />
          </div>
        </div>
      </div>
    </section>;
}